// @ts-nocheck
import { actionCreatorFactory } from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { combineReducers } from 'redux';

export const NAMESPACE = 'customer';
export const NAME = 'fetch';

export type State = {
    readonly isGuest: boolean;
    readonly isInitial: boolean;
};

const initialState: State = {
    isGuest: true,
    isInitial: true,
};

const createAction = actionCreatorFactory(NAMESPACE);

export const setIsGuest = createAction<boolean>('SET');

export const getIsGuest = (state: State) => state[NAMESPACE][NAME].isGuest;
export const getIsInitial = (state: LocalState) => state[NAMESPACE][NAME].isInitial;
export const getInitialState = () => initialState;

const reducer = reducerWithInitialState<State>(initialState).case(setIsGuest, (state, payload) => ({
    isGuest: payload,
    isInitial: false,
}));

export const getCustomerReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});
